







import Vue from 'vue'
import Nav from '@/components/Nav.vue'

export default Vue.extend({
  name: 'App',
  components: {
    'sidebar-nav': Nav
  },
  data () {
    return {
      colorMode: 'light' as 'dark' | 'light',
      darkModeMediaQuery: null as MediaQueryList | null,
      onMediaQueryChange: null as ((e: MediaQueryListEvent) => void) | null,
      onVisibilityChange: null as (() => void) | null
    }
  },
  created () {
    // Android 企业微信客户端不支持 CSS 媒体查询，通过 User-Agent 判断
    if (/ColorScheme\/Dark/i.test(navigator.userAgent)) {
      this.colorMode = 'dark'
      return
    }

    // iOS / 其他平台使用 CSS 媒体查询，并监听系统主题变化
    if (window.matchMedia) {
      this.darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      this.colorMode = this.darkModeMediaQuery.matches ? 'dark' : 'light'

      this.onMediaQueryChange = (e: MediaQueryListEvent) => {
        this.colorMode = e.matches ? 'dark' : 'light'
      }

      // Safari 14 以下 / 旧版 iOS WebView 不支持 addEventListener，需降级到 addListener
      if (this.darkModeMediaQuery.addEventListener) {
        this.darkModeMediaQuery.addEventListener('change', this.onMediaQueryChange)
      } else {
        (this.darkModeMediaQuery as any).addListener(this.onMediaQueryChange)
      }

      // iOS 上用户在系统设置切换外观时，应用进入后台再回来，change 事件不一定触发
      // 通过 visibilitychange 在回到前台时主动重新读取一次
      this.onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          this.colorMode = (this.darkModeMediaQuery as MediaQueryList).matches ? 'dark' : 'light'
        }
      }
      document.addEventListener('visibilitychange', this.onVisibilityChange)
    }
  },
  beforeDestroy () {
    if (this.darkModeMediaQuery && this.onMediaQueryChange) {
      if (this.darkModeMediaQuery.removeEventListener) {
        this.darkModeMediaQuery.removeEventListener('change', this.onMediaQueryChange)
      } else {
        (this.darkModeMediaQuery as any).removeListener(this.onMediaQueryChange)
      }
    }
    if (this.onVisibilityChange) {
      document.removeEventListener('visibilitychange', this.onVisibilityChange)
    }
  }
})
